module.exports = __webpack_public_path__ + "static/media/casa-tragaluz.055de2c1.jpg";